import { useMutation } from '@tanstack/react-query';

import { EnableRealTimeStatsData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const enableRealTimeStats = (data: EnableRealTimeStatsData): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[data.platform]}/pages/enable-realtime-stats`, data);
};

type EnableRealTimeStatsOptions = {
  config?: MutationConfig<typeof enableRealTimeStats>;
};

export function useEnableRealTimeStats({ config }: EnableRealTimeStatsOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: enableRealTimeStats,
  });
}
